export default (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.69893 13.5238C6.69893 13.1096 7.03471 12.7738 7.44893 12.7738H8.72133C9.13554 12.7738 9.47133 13.1096 9.47133 13.5238C9.47133 13.9381 9.13554 14.2738 8.72133 14.2738H7.44893C7.03471 14.2738 6.69893 13.9381 6.69893 13.5238Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.762 13.0464C13.762 12.6322 14.0978 12.2964 14.512 12.2964H16.5857C16.9999 12.2964 17.3357 12.6322 17.3357 13.0464C17.3357 13.4606 16.9999 13.7964 16.5857 13.7964H14.512C14.0978 13.7964 13.762 13.4606 13.762 13.0464Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.38734 14.1954C8.01646 14.0109 7.86534 13.5607 8.0498 13.1899L9.69976 9.8724C9.88422 9.50153 10.3344 9.3504 10.7053 9.53486C11.0762 9.71932 11.2273 10.1695 11.0428 10.5404L9.39285 13.8578C9.2084 14.2287 8.75821 14.3798 8.38734 14.1954Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7929 16.7149C11.4601 16.4683 11.3903 15.9986 11.637 15.6658L13.9095 12.5998C14.1561 12.267 14.6259 12.1972 14.9586 12.4439C15.2914 12.6905 15.3612 13.1602 15.1146 13.493L12.8421 16.559C12.5954 16.8918 12.1257 16.9616 11.7929 16.7149Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1451 9.49131C10.54 9.36639 10.9614 9.58527 11.0864 9.98019L12.9546 15.8862C13.0795 16.2811 12.8606 16.7026 12.4657 16.8275C12.0708 16.9524 11.6494 16.7335 11.5244 16.3386L9.65621 10.4326C9.53129 10.0377 9.75017 9.61624 10.1451 9.49131Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.18934 3.43934C4.47064 3.15804 4.85217 3 5.25 3H9C9.41421 3 9.75 3.33579 9.75 3.75C9.75 4.16421 9.41421 4.5 9 4.5H5.25L5.25 20.25H18.75V4.5H15C14.5858 4.5 14.25 4.16421 14.25 3.75C14.25 3.33579 14.5858 3 15 3H18.75C19.1478 3 19.5294 3.15804 19.8107 3.43934C20.092 3.72065 20.25 4.10218 20.25 4.5V20.25C20.25 20.6478 20.092 21.0294 19.8107 21.3107C19.5294 21.592 19.1478 21.75 18.75 21.75H5.25C4.85218 21.75 4.47065 21.592 4.18934 21.3107C3.90804 21.0294 3.75 20.6478 3.75 20.25V4.5C3.75 4.10217 3.90804 3.72064 4.18934 3.43934Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C11.2044 3 10.4413 3.31607 9.87868 3.87868C9.31607 4.44129 9 5.20435 9 6H15C15 5.20435 14.6839 4.44129 14.1213 3.87868C13.5587 3.31607 12.7956 3 12 3ZM8.81802 2.81802C9.66193 1.97411 10.8065 1.5 12 1.5C13.1935 1.5 14.3381 1.97411 15.182 2.81802C16.0259 3.66193 16.5 4.80653 16.5 6V6.75C16.5 7.16421 16.1642 7.5 15.75 7.5H8.25C7.83579 7.5 7.5 7.16421 7.5 6.75V6C7.5 4.80653 7.97411 3.66193 8.81802 2.81802Z"
      fill="currentColor"
    />
  </>
);
